export default __webpack_public_path__ + "static/media/bidifylogo_xdai.34e0b48c.png";